$(document).ready(function(){
  var t;
  var _suppressSearch = false;

  function buildSearchParams() {
    var params = new URLSearchParams();

    var searchValue = $("#auction_search").val();
    if (searchValue && searchValue.trim() !== '') {
      params.set('search', searchValue.trim());
    }

    var checked = [];
    $("input[name='category_search[]']:checked").each(function() {
      checked.push($(this).val());
    });
    if (checked.length > 0) {
      checked.forEach(function(category) {
        params.append('category_search[]', category);
      });
    }

    var locations = $("#auction_locations").val();
    if (locations && locations.length > 0) {
      if (Array.isArray(locations)) {
        locations.forEach(function(location) {
          params.append('auction_locations[]', location);
        });
      } else {
        params.append('auction_locations[]', locations);
      }
    }

    return params;
  }

  function updateURL() {
    var params = buildSearchParams();
    params.set('active_search', $("#active_search").val() || 'true');

    var newURL = window.location.pathname;
    var queryString = params.toString();
    if (queryString) {
      newURL += '?' + queryString;
    }

    try {
      window.history.pushState({path: newURL}, '', newURL);
      setTimeout(function() {
        var currentURL = window.location.pathname + window.location.search;
        if (currentURL !== newURL) {
          window.history.replaceState({path: newURL}, '', newURL);
        }
      }, 50);
    } catch(e) {
      window.history.replaceState({path: newURL}, '', newURL);
    }
  }

  function populateFiltersFromURL() {
    var urlParams = new URLSearchParams(window.location.search);

    var searchParam = urlParams.get('search');
    if (searchParam) {
      $("#auction_search").val(searchParam);
    }

    var categoryParams = urlParams.getAll('category_search[]');
    if (categoryParams.length > 0) {
      $("input[name='category_search[]']").prop('checked', false);
      categoryParams.forEach(function(category) {
        var escapedCategory = category.replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, "\\$&");
        $("input[name='category_search[]'][value='" + escapedCategory + "']").prop('checked', true);
      });
    }

    var locationParams = urlParams.getAll('auction_locations[]');
    if (locationParams.length > 0) {
      $("#auction_locations").val(locationParams).trigger('change');
      if (typeof reinitializeSelect2 === 'function') {
        setTimeout(function() {
          reinitializeSelect2();
          $("#auction_locations").val(locationParams).trigger('change');
        }, 100);
      }
    }
  }

  populateFiltersFromURL();

  window.addEventListener('popstate', function(event) {
    var returningFromAd = false;
    try { returningFromAd = !!sessionStorage.getItem('scrollPosition'); } catch(e) {}

    if (returningFromAd) {
      _suppressSearch = true;
      populateFiltersFromURL();
      setTimeout(function() { _suppressSearch = false; }, 200);
      return;
    }

    populateFiltersFromURL();
    if (window.performAuctionSearch) {
      window.performAuctionSearch();
    }
  });

  $(document).on('click', '#pills-auction-announcement-tab',  function() {
    second_pagination();
  });

  $(document).on('click', '#pills-notice-sale-tab',  function() {
    third_pagination();
  });

  $(document).on("click", ".online-auction-btn", function(){
    $('.online_auctions_categories').removeClass('hide');
    $('.auction_notices_categories').addClass('hide');
    $('.sale_ads_categories').addClass('hide');
  });

  $(document).on("click", ".auction-notice-btn", function(){
    $('.online_auctions_categories').addClass('hide');
    $('.auction_notices_categories').removeClass('hide');
    $('.sale_ads_categories').addClass('hide');
  });

  $(document).on("click", ".sales-ad-btn", function(){
    $('.online_auctions_categories').addClass('hide');
    $('.auction_notices_categories').addClass('hide');
    $('.sale_ads_categories').removeClass('hide');
  });

 	$(document).on("click", ".active_search", function(){
    $("#active_search").val("true");
    $('.end_search').removeClass('btn-primary');
    $('.active_search').addClass('btn-primary');
  });

  $(document).on("click", ".end_search", function(){
    $("#active_search").val("false");
    $('.active_search').removeClass('btn-primary');
    $('.end_search').addClass('btn-primary');
  });

  $(document).on("keyup", "#auction_offer", function() {
    var offerValue = $("#auction_offer").val().trim();
    var verify_identification_status = $("#verify_identification_status").val();

    var normalized = offerValue.replace(',', '.');
    var isNumber = !isNaN(normalized);
    var isWhole = (parseFloat(normalized) % 1 === 0);

    if (offerValue && verify_identification_status === "true") {
      $(".auction_offer_button").removeClass("disableattchmentbutton");
    } else {
      $(".auction_offer_button").addClass("disableattchmentbutton");
    }
  });


  function performAuctionSearch() {
    if (_suppressSearch) return;
    var checked = []
    $("input[name='category_search[]']:checked").each(function ()
    {
        checked.push($(this).val());
    });
    clearTimeout(t);
    t = setTimeout(function () {
      if ($("#loader-image").length) {
        $("#loader-image").show();
      }

      var params = buildSearchParams();
      params.set('active_search', $("#active_search").val());
      params.set('filter', 'true');

      // Reset page parameters when performing a new search (not pagination)
      params.delete('page');

      updateURL();

      $.ajax({
        url: '/search/auction_filter?' + params.toString(),
        type: 'GET',
        dataType: 'script',
        success: function() {
          setTimeout(function() {
            if (typeof updateURL === 'function') {
              updateURL();
            }
          }, 100);
        }
      });
    }, 500);
  }

  window.performAuctionSearch = performAuctionSearch;
  window.updateURL = updateURL;

  $(document).on('click', '.active_search, .end_search',  function() {
    performAuctionSearch();
  });

  var enterKeyPressed = false;

  $(document).on('keypress', '#auction_search', function(e) {
    if (e.which === 13 || e.keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
      enterKeyPressed = true;
      clearTimeout(t);
      updateURL();
      performAuctionSearch();
      setTimeout(function() {
        enterKeyPressed = false;
      }, 100);
    }
  });

  $(document).on('keyup', '#auction_search', function(e) {
    if (e.which === 13 || e.keyCode === 13 || enterKeyPressed) {
      return;
    }
    setTimeout(function() {
      updateURL();
    }, 10);
    performAuctionSearch();
  });

  $(document).on('click', 'input[name="category_search[]"]', function() {
    updateURL();
    performAuctionSearch();
  });

  $(document).on('change', '#auction_locations', function() {
    if (_suppressSearch) return;
    updateURL();
    performAuctionSearch();
  });

  $(document).on("click", "#pills-online-auction-tab", function(){
    $(".online_auction_section").removeClass("hide");
    $(".auction_notice_section").addClass("hide");
    $(".sales_ad_section").addClass("hide");
  });

  $(document).on("click", "#pills-auction-announcement-tab", function(){
    $(".online_auction_section").addClass("hide");
    $(".auction_notice_section").removeClass("hide");
    $(".sales_ad_section").addClass("hide");
  });

  $(document).on("click", "#pills-notice-sale-tab", function(){
    $(".online_auction_section").addClass("hide");
    $(".auction_notice_section").addClass("hide");
    $(".sales_ad_section").removeClass("hide");
  });

  if ($('.pagination').length) {
    $(document).off('scroll.firstPagination').on('scroll.firstPagination', function() {
      var url = $('.pagination .next_page').attr('href');
      if (url && $(window).scrollTop() + $(window).height() >= $(document).height() - 200) {
        $('.pagination').text("Pieni hetki...");
        return $.getScript(url);
      }
    });
  }

  $(document).on("click", ".view-more-link", function(){
    $('.view-less').removeClass('hide');
    $('.view-more').addClass('hide');
    $('.view-more-info').removeClass('hide');
  });

  $(document).on("click", ".view-less-link", function(){
    $('.view-less').addClass('hide');
    $('.view-more').removeClass('hide');
    $('.view-more-info').addClass('hide');
  });
});


function second_pagination(){
  if ($('.second_pagination').length) {
    $(document).off('scroll.secondPagination').on('scroll.secondPagination', function() {
      var url = $('.second_pagination .next_page').attr('href');
      if (url && $(window).scrollTop() + $(window).height() >= $(document).height() - 200) {
        $('.second_pagination').text("Pieni hetki...");
        return $.getScript(url);
      }
    });
  }
}

function third_pagination(){
  if ($('.third_pagination').length) {
    $(document).off('scroll.thirdPagination').on('scroll.thirdPagination', function() {
      var url = $('.third_pagination .next_page').attr('href');
      if (url && $(window).scrollTop() + $(window).height() >= $(document).height() - 200) {
        $('.third_pagination').text("Pieni hetki...");
        return $.getScript(url);
      }
    });
  }
}

